import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import Layout from "./Layout";

export default connect(null, { post, editTask })(Layout);
